import { render, staticRenderFns } from "./BasicSelectComplete.vue?vue&type=template&id=58e81630"
import script from "./BasicSelectComplete.vue?vue&type=script&lang=js"
export * from "./BasicSelectComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports